import React from 'react'
import {Row, Col} from 'reactstrap'
import {FaFacebook, FaYoutube} from 'react-icons/fa'
import LazyLoad from 'react-lazyload'

import Footer from './Footer.styled'

const FooterComponent = () => (
  <Footer>
    <Footer.SectionsWrapper>
      <Row>
        <Col md={4}>
          <Footer.Section>
            <Footer.SectionHeading>
              <LazyLoad
                height={120}
                once
                offset={250}
              >
                <Footer.Logo
                  height={120}
                  width={120}
                  src='https://res.cloudinary.com/ngabds/image/upload/f_auto,q_auto,w_240,h_240/v1617419887/static-images/ngabds_logo_youtube_video_bvcsfy.png'
                  srcSet='
                    https://res.cloudinary.com/ngabds/image/upload/f_auto,q_auto,w_120,h_120/v1617419887/static-images/ngabds_logo_youtube_video_bvcsfy.png 120w,
                    https://res.cloudinary.com/ngabds/image/upload/f_auto,q_auto,w_240,h_240/v1617419887/static-images/ngabds_logo_youtube_video_bvcsfy.png 240w,
                  '
                  sizes='120px'
                  alt='NgaBDS logo'
                />
              </LazyLoad>

              <noscript>
                <Footer.Logo
                  height={120}
                  width={120}
                  src='https://res.cloudinary.com/ngabds/image/upload/f_auto,q_auto,w_240,h_240/v1617419887/static-images/ngabds_logo_youtube_video_bvcsfy.png'
                  srcSet='
                    https://res.cloudinary.com/ngabds/image/upload/f_auto,q_auto,w_120,h_120/v1617419887/static-images/ngabds_logo_youtube_video_bvcsfy.png 120w,
                    https://res.cloudinary.com/ngabds/image/upload/f_auto,q_auto,w_240,h_240/v1617419887/static-images/ngabds_logo_youtube_video_bvcsfy.png 240w,
                  '
                  sizes='120px'
                  alt='NgaBDS logo'
                />
              </noscript>
            </Footer.SectionHeading>

            <Footer.SectionBody>NgaBDS.com - Chuyên trang mua bán nhà đất Quận 7, Nhà Bè. Ký gửi nhà đất Quận 7, Nhà Bè khu vực TPHCM và khu vực lân cận. Đảm bảo an toàn pháp lý trong suốt quá trình và hỗ trợ đầy đủ quy trình, thủ tục trong suốt quá trình mua bán.</Footer.SectionBody>
          </Footer.Section>
        </Col>

        <Col md={4}>
          <Footer.Section>
            <Footer.SectionHeading id='contact'>Thông tin liên hệ</Footer.SectionHeading>

            <Footer.SectionBody>
              <Footer.ContactItem>
                Điện thoại:
                {' '}
                <strong><a href='tel:0978800347'>0978 800 347</a></strong>
              </Footer.ContactItem>

              <Footer.ContactItem>
                Địa chỉ:
                {' '}
                <strong>984 Huỳnh Tấn Phát, Tân Phú, Quận 7, HCM</strong>
              </Footer.ContactItem>

              <Footer.ContactItem>
                Giờ làm việc:
                {' '}
                <strong>Thứ 2 - Chủ nhật</strong>
              </Footer.ContactItem>

              <Footer.ContactItem>
                Website được thực hiện bởi:
                {' '}
                <a href='https://cv.khanhpv.com'><strong>KhanhPV</strong></a>
              </Footer.ContactItem>
            </Footer.SectionBody>
          </Footer.Section>
        </Col>

        <Col md={4}>
          <Footer.Section>
            <Footer.SectionHeading>Liên kết</Footer.SectionHeading>

            <Footer.SectionBody>
              <Footer.SocialItemsWrapper>
                <Footer.SocialItem
                  href='https://www.facebook.com/ms.ngabds/'
                  name='facebook'
                >
                  <FaFacebook />
                </Footer.SocialItem>

                <Footer.SocialItem
                  href='https://www.youtube.com/channel/UCe_3q-XcapV110uKJECP5ww'
                  name='youtube'
                >
                  <FaYoutube />
                </Footer.SocialItem>
              </Footer.SocialItemsWrapper>
            </Footer.SectionBody>
          </Footer.Section>
        </Col>
      </Row>
    </Footer.SectionsWrapper>
  </Footer>
)

export default FooterComponent
